import { registerSW } from 'virtual:pwa-register';

// Long-lived tabs (this app runs installed on dealership devices and can
// stay open, focused, for days) don't otherwise get an update check —
// Workbox only checks for a new service worker on page load or when the
// tab regains focus. Polling registration.update() guarantees a new
// deploy gets detected — and the tab silently reloaded, since
// registerType: 'autoUpdate' in vite.config.ts reloads automatically once
// the new service worker activates — within this interval even if nobody
// ever touches the tab.
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

export function initServiceWorkerUpdates(): void {
  registerSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) {
        return;
      }

      setInterval(() => {
        registration.update();
      }, UPDATE_CHECK_INTERVAL_MS);
    },
  });
}
